import { render } from "./CompanySection.vue?vue&type=template&id=5b31f110&scoped=true"
import script from "./CompanySection.vue?vue&type=script&lang=js"
export * from "./CompanySection.vue?vue&type=script&lang=js"

import "./CompanySection.vue?vue&type=style&index=0&id=5b31f110&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rights.tokyo/rights.tokyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b31f110"]])

export default __exports__